//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const querystring = require('querystring')
const axios = require('axios')

export default {
  data() {
    return {
      biometricsAvailable: false,
      showPassword: false,
      loginMethod: null,
      //password: 'test1234',
      //username: 'testkev1',
      password: '',
      username: '',
      mode: 'username',
      loading: true,
      authenticationStatus: null,
      authenticating: false,
      forcingAuthentication: false,
      visible: false
    }
  },
  async mounted() {
    window.loadGlobalIframe = this.loadGlobalIframe
    this.checkBiometrics()
    this.$root.$on('login_hide', async () => {
      this.visible = false
    })
    this.$root.$on('login_show', async () => {
      this.visible = true
      this.forcingAuthentication = false

      const res = await this.$CapacitorStorage.get({ key: 'login_mode' })
      let login_mode = _.get(res, 'value')

      if (login_mode == 'auto') {
        this.forceLogin()
      }
      if (login_mode == 'biometric') {
        this.forceBiometricLogin()
      }
      if (login_mode == 'username') {
        const res_username = await this.$CapacitorStorage.get({ key: 'username' })
        this.username = _.get(res_username, 'value')

        const res_password = await this.$CapacitorStorage.get({ key: 'password' })
        this.password = _.get(res_password, 'value')
      }
    })

    this.$root.$on('login_force', async () => {
      const res = await this.$CapacitorStorage.get({ key: 'login_mode' })
      let login_mode = _.get(res, 'value')

      if (login_mode == 'auto') {
        this.forceLogin()
      }
      if (login_mode == 'biometric') {
        this.forceBiometricLogin()
      }
    })
  },
  watch: {
    visible: function (value) {
      this.checkBiometrics()
    }
  },
  computed: {},
  methods: {
    async checkBiometrics() {
            console.log('checkBiometrics');
      if(this.platform == 'web')
        return;

      this.$CapacitorNativeBiometric.isAvailable().then(
        (result) => {
          //console.log('checkBiometrics', result);
          const isAvailable = result.isAvailable
          //console.log('checkBiometrics isAvailable', result.isAvailable)
          //console.log('checkBiometrics biometryType', result.biometryType)

          if (isAvailable) {
            this.biometricsAvailable = true
            this.mode = 'biometric'
            let types = ['NONE', 'TOUCH_ID', 'FACE_ID', 'FINGERPRINT', 'FACE_AUTHENTICATION', 'IRIS_AUTHENTICATION'];
            this.loginMethod = _.get(types, result.biometryType)
          }
        },
        (error) => {
          console.log('checkBiometrics error', error);
        }
      )
    },
    async forceLogin() {
      if(this.platform == 'web')
        return;
      this.$CapacitorNativeBiometric
        .getCredentials({
          server: 'www.netbet.com'
        })
        .then((credentials) => {
          console.log('credentials', credentials)
          this.forcingAuthentication = true
          this.visible = true
          this.login(credentials.username, credentials.password, true)
        })
    },
    async forceBiometricLogin() {
      if(this.platform == 'web')
        return;
      this.$CapacitorNativeBiometric.isAvailable().then(
        (result) => {
          const isAvailable = result.isAvailable

          if (isAvailable) {
            this.biometricsAvailable = true
            // Get user's credentials

            this.$store.commit('setLocalAuthAt', luxon.DateTime.now().toISO())
            this.$CapacitorNativeBiometric
              .getCredentials({
                server: 'www.netbet.com'
              })
              .then((credentials) => {
                // Authenticate using biometrics before logging the user in
                this.$CapacitorNativeBiometric
                  .verifyIdentity({
                    reason: 'Face/Touch ID',
                    title: 'Authenticate',
                    subtitle: '',
                    description: ''
                  })
                  .then(
                    () => {
                      this.forcingAuthentication = true
                      this.visible = true
                      setTimeout(() => {
                        this.$store.commit('setLocalAuthAt', null)
                      }, 2000)
                      // Authentication successful
                      this.login(credentials.username, credentials.password, true)
                    },
                    (error) => {
                      // Failed to authenticate
                      setTimeout(() => {
                        this.$store.commit('setLocalAuthAt', null)
                      }, 2000)
                    }
                  )
              })
          }
        },
        (error) => {
          // Couldn't check availability
        }
      )
    },

    async signIn() {
      this.authenticating = true
      this.login(this.username, this.password)
    },
    
    async loginRetryToken(vars, user_params) {

      let domain_configs = {
        'netbet.ro': {
          'country' : 'RO',
          'bookmaker' : 'netbetro',
        },
        'netbet.co.uk': {
          'country' : 'UK',
          'bookmaker' : 'netbetie',
        },
        'netbet.ie': {
          'country' : 'IE',
          'bookmaker' : 'netbetie',
        },
        'netbet.com': {
          'country' : 'US',
          'bookmaker' : 'netbetcom',
        },
        'netbet.com.mx': {
          'country' : 'MX',
          'bookmaker' : 'netbetlatam',
        }
      }

      let domain = vars['domain'];
      let lang = vars['lang'];
      let api_url = 'https://api.' + domain;
      if(process.env.ENVIRONMENT == 'staging') {
        api_url = 'https://staging-api.' + domain;
      }
      let params = {}
      params['token'] = vars['temporary_token'];
      params['domain'] = vars['domain'];
      params['lang'] = vars['lang'];
      params['website'] = vars['website'];
      params['website'] = 'sport'
      params['device'] = 'mobile'
      params['app'] = this.operator_app

      console.log('loginRetryToken', domain, vars);

      let response = null;
      try {
        response = await axios.get(api_url + '/auth/loginWithToken?' + querystring.stringify(params), {withCredentials: true, })      
      } catch(e) {
        console.log('loginWithToken', e.message)
        return false
      }
      if (!_.get(response, 'data.status')) {
        return;
      }

      if (_.get(response, 'data.status')) {
        
        this.$config.COUNTRY = _.get(domain_configs, domain + '.country');
        this.$config.BOOKMAKER = _.get(domain_configs, domain + '.bookmaker');

        this.$config.GLOBAL_IFRAME = "https://global." + domain+ "/sport"
        if(process.env.ENVIRONMENT == 'staging') {
          this.$config.GLOBAL_IFRAME = "https://global-staging." + domain+ "/sport"
        }
        this.$config.OPERATOR_API = api_url;
        this.$config.OPERATOR_API_LANG = _.get(params, 'lang');

        if(lang == 'br') { //hack
          this.$config.GLOBAL_IFRAME = "https://global." + domain+ "/br/sport"
          if(process.env.ENVIRONMENT == 'staging') {
            this.$config.GLOBAL_IFRAME = "https://global-staging." + domain+ "/sport"
          }
          this.$config.COUNTRY = 'BR'
        }
        this.$root.$emit('update_config')
        this.processResponse(response, user_params)
      }

      console.log('loginRetryToken', response);


    },

    async processResponse(response, params) {
        console.log('processResponse', response, params)

        let username = _.get(params, 'username')
        let password = _.get(params, 'password')
        if (_.get(response, 'data.status')) {
          if (!_.get(response, 'data.data.sportify.access_token')) {
            this.authenticating = false
            this.forcingAuthentication = false
            alert("ERROR: No Access Token");
            return;
          }

          //alert(_.get(response, 'data.data.sportify.access_token'));
          
          //store the token
          this.$store.commit('auth/storeAccessToken',  _.get(response, 'data.data.sportify.access_token'))
          //alert(_.get(response, 'data.data.sportify.access_token'));
          this.loadGlobalIframe('token', { token: _.get(response, 'data.data.sportify.access_token') })
          //this.loadGlobalIframe('request_sport_token')
          this.$store.commit('auth/storeUser', { name: username })
          setTimeout(() => {
            this.close()
            this.authenticating = false
            this.loadGlobalIframe('hide_iframe', {}, true)
            //this.loadGlobalIframe('request_sport_token')
            this.$root.$emit('update_balance')
            setTimeout(() => {
              this.$root.$emit('update_balance')
            }, 300)
            setTimeout(() => {
              this.$root.$emit('update_balance')
              this.loadGlobalIframe('request_sport_token')
              //this.$sportify().auth.storeUser(_.get(response, 'data.data.user'))
              this.forcingAuthentication = false
              if(this.silent) {
                this.visible = false;
              }

            }, 1000)


            try {
              const user_id = _.get(response, 'data.data.user.id');

              dataLayer.push({
                  'event': 'login_ok',
                  'eventCategory': 'login',
                  'eventAction': 'click',
                  'user_id': user_id,
                  'eventLabel': this.lang + '/login_ok',
              })
              
            } catch (e) {
              
            }

          }, 1000)

          if (this.mode) {
            await this.$CapacitorStorage.set({ key: 'username', value: username })
            await this.$CapacitorStorage.set({ key: 'password', value: password })
            await this.$CapacitorStorage.set({ key: 'login_mode', value: this.mode })
          }
          await this.$CapacitorNativeBiometric.deleteCredentials({ server: 'www.netbet.com' }).then();
          await this.$CapacitorNativeBiometric
            .setCredentials({
              username: username,
              password: password,
              server: 'www.netbet.com'
            })
            .then()
        }

    },

    async login(username, password, silent = false) {

      let domain = this.$config.OPERATOR_DOMAIN
      
      let params = {}
      params['username'] = username
      params['password'] = password
      params['rememberMe'] = 1
      params['website'] = 'sport'
      params['lang'] = this.$config.OPERATOR_API_LANG
      params['device'] = 'mobile'
      params['app'] = this.operator_app
      params['app_version'] = 1
      params['cache_version'] = 39719
      params['global_project'] = 1

      try {
        const response = await axios.post(this.$config.OPERATOR_API + '/auth/login', querystring.stringify(params), {
            withCredentials: true,
        })
        //const response = await this.$CapacitorHttp.get({'url' : this.$config.OPERATOR_API + '/auth/login?' + querystring.stringify(params)})

        console.log('logged in', response)
        console.log('logged in', _.get(response, 'data.data.sportify.access_token'))

        if (!_.get(response, 'data.status')) {
          if (!silent) {
            if(_.get(response, 'data.data.temporary_token')) {
              if(_.get(response, 'data.data.domain') == domain) {
                //alert('loginRetryToken')
                this.loginRetryToken(_.get(response, 'data.data'), params); //retry login with token
              } else {
                alert(_.get(response, 'data.message'))
                //alert(_.get(response, 'data.message') + "\n" + this.$config.OPERATOR_API + "\n" + querystring.stringify(params))
              }
            } else {
                alert(_.get(response, 'data.message'))
                //alert("1. " + _.get(response, 'data.message') + "\n" + this.$config.OPERATOR_API + "\n" + querystring.stringify(params))
            }
          }
          this.authenticating = false
          this.forcingAuthentication = false
        }

        if (_.get(response, 'data.status')) {
          this.processResponse(response, params)
        }
      } catch (e) {
        this.authenticating = false
        this.forcingAuthentication = false
        if(this.silent) {
          this.visible = false;
        }
        alert(e.message)
      }
    },
    async storeToken(token) {
      await this.$sportify().auth.storeToken(token)
      let res = await this.$store.dispatch('auth/refreshBalance', true)

      this.$root.$emit('update_balance')
    },
    openRegistration() {
      this.visible = false
      this.loadGlobalIframe('open_page', { url: '/registration' })
    },
    close() {
      this.visible = false
    },
    togglePassword() {
      this.showPassword = !this.showPassword
    }
  }
}
